import requestDisplaySetCreationForStudy from '../../Panels/requestDisplaySetCreationForStudy';
import { isImportedStudyUID } from './importStudySession';

const DICOM_LOCAL_DATA_SOURCE = 'dicomlocal';

/**
 * Routes display-set creation for imported studies through dicomlocal while
 * leaving server-backed studies on the active data source.
 */
export function createStudyDisplaySetRequester(
  extensionManager: AppTypes.ExtensionManager,
  activeDataSource: ReturnType<AppTypes.ExtensionManager['getActiveDataSource']>[0]
) {
  return (
    displaySetService: AppTypes.DisplaySetService,
    StudyInstanceUID: string,
    madeInClient?: boolean
  ) => {
    const dataSource = isImportedStudyUID(StudyInstanceUID)
      ? extensionManager.getDataSourceInstance(DICOM_LOCAL_DATA_SOURCE)
      : activeDataSource;

    return requestDisplaySetCreationForStudy(
      dataSource,
      displaySetService,
      StudyInstanceUID,
      madeInClient
    );
  };
}
